(() => {
  if (window.__menuSilentControlsV1) return;
  window.__menuSilentControlsV1 = true;

  const controlSelector = [
    'full-menu .menu-item-has-children > a',
    'full-menu .l2-link-simple[data-target]',
    'full-menu .l3-link[data-target]',
    'full-menu .mega-menu-columns__heading',
    'full-menu .l2-summary--tab[data-target]'
  ].join(',');

  function getControl(target) {
    if (!(target instanceof Element)) return null;
    const control = target.closest(controlSelector);
    if (control) return control;
    const link = target.closest('full-menu a, #mobile-menu a, mobile-menu-panels a');
    if (!link) return null;
    const href = (link.getAttribute('href') || '').trim();
    if (!href || href === '#' || href === '/#' || /^javascript:/i.test(href)) return link;
    if (href.endsWith('#')) {
      const destination = new URL(href, location.href);
      const root = new URL(window.Shopify?.routes?.root || '/', location.origin);
      if (destination.origin === root.origin &&
          destination.pathname.replace(/\/$/, '') === root.pathname.replace(/\/$/, '')) return link;
    }
    return null;
  }

  function activate(control) {
    if (control.matches('.l2-link-simple, .l3-link, .l2-summary--tab, .menu-item-has-children > a')) {
      control.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
    }
  }

  document.addEventListener('click', (event) => {
    const control = getControl(event.target);
    if (!control) return;
    event.preventDefault();
    activate(control);
  }, true);

  document.addEventListener('auxclick', (event) => {
    if (getControl(event.target)) event.preventDefault();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== ' ') return;
    const control = getControl(event.target);
    if (!control || control.tagName !== 'A') return;
    event.preventDefault();
    control.click();
  });

  document.addEventListener('focusin', (event) => {
    const control = getControl(event.target);
    if (control) activate(control);
  });
})();
